<template>
  <v-container fluid fill-height class="px-0">
    <!-- SOME ADMIN CONTENT -->
    DASHBOARD ADMIN
  </v-container>
</template>
<script>
export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
  }),
  mounted() {
    if (this.user.role == "PRODUCTION") {
      this.$router.push("/batches").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    } else if (this.user.role == "B2B") {
      this.$router.push("/orders").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    } else if (this.user.role == "LOGISTICS") {
      this.$router.push("/logistics").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    } else if (this.user.role == "QUALITY") {
      this.$router.push("/batches").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    } else if (this.user.role == "CEPARIUM") {
      this.$router.push("/cepario-production").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    } else {
      let permissions = localStorage.getItem("permissions");
      permissions = permissions.split(",");
      if (permissions.find((permission) => permission == "show_op")) {
        this.$router.push("/orders").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        this.$router.push("/batches").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    }
  },
};
</script>
